import { ApiTags, rootApi } from "../../../../services/rootApi";

const TAG = ApiTags.Feedback;
export interface IPaymentButton {
  id: string
  amount: string,
  rollNo: string,
  date: string,
  referenceNo: string,
  documentLink: string,
  isForeignCurrecny?: boolean
  currencycode?: string
}
export interface IDeferment {
  id?: string
  amount?: string,
  rollNo?: string,
  dueDate?: string,
  remark?: string,
  status?: number
}

export interface ICurrencyEntity {
  currencyName: string;
  currencySymbol: string;
  isoCurrencyCode: string;
  transactionCurrencyId: string;
}

const getTags = (entities: ICurrencyEntity[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.transactionCurrencyId })),
  TAG,
];
const getTags1 = (entities: IDeferment[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.id })),
  TAG,
];

const paymentButtonApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    createPayment: builder.mutation<IPaymentButton, Partial<IPaymentButton>>({
      query: (payment) => ({
        url: "/PaymentButton",
        method: "POST",
        body: payment
      }),
      invalidatesTags: (result) => result ? [{ type: TAG, id: result.id }, TAG] : [TAG]
    }),
    createDeferment: builder.mutation<IDeferment[], Partial<IDeferment>>({
      query: (payment) => ({
        url: "/PaymentButton/Deferment",
        method: "POST",
        body: payment
      }),
      invalidatesTags: (result, err, args) => {
        if (err) return [];
        return [{ type: TAG, id: args.id }]
      }
    }),

    getDeferment: builder.query<IDeferment[], { id: string }>({
      query: ({id}) => `/PaymentButton/${id}`,
      providesTags: (result) => (result ? getTags1(result) : [TAG]),
    }),

    getCurrencyCode: builder.query<ICurrencyEntity[], void>({
      query: () => "/PaymentButton/currencyCode",
      providesTags: (result) => (result ? getTags(result) : [TAG]),
    }),

    DeleteLine: builder.mutation<void, string>({
      query: (lineId) => {
        return {
          url: `/PaymentButton/DeleteLine/${lineId}`,
          method: 'DELETE',
        }
      }
    }),
    updateDefermentLine: builder.mutation<IDeferment, Partial<IDeferment>>({
      query: (lineId) => {
        return {
          url: `/PaymentButton/${lineId.id}`,
          method: 'PUT',
          body: lineId
        }
      }
    })
  })
})

export const {
  useGetDefermentQuery,
  useLazyGetDefermentQuery,
  useCreatePaymentMutation,
  useCreateDefermentMutation,
  useGetCurrencyCodeQuery,
  useDeleteLineMutation,
  useUpdateDefermentLineMutation,
} = paymentButtonApi;